import {
  BO_BOKADE_AKTIVITETER_SETTING,
  BO_BOKNINGSRUBRIKER_SETTING,
  BO_DATUM_FRAN_SETTING,
  BO_DATUM_TILL_SETTING,
  BO_IS_VALID_DATE_FRAN_SETTING,
  BO_IS_VALID_DATE_TILL_SETTING,
  BO_PLANERADE_AKTIVITETER_SETTING,
  BO_TYPE_CONDITION_SETTING,
} from '../../../../../../Utils/LocalStorage/localStorageKeys';
import { useLocalStorage } from '../../../../../../Hooks/useLocalStorage';
import { ITypeTreeConditionObject } from '../../../../../../Types/UrvalTypes';
import { IBokningsrubrik } from '../../../ObjektVyer/Aktivitet/AktivitetResursValjare';

const PLANERING_SETTINGS = {
  planeradeAktiviteter: {
    key: BO_PLANERADE_AKTIVITETER_SETTING,
    default: true,
  },
  bokadeAktiviteter: { key: BO_BOKADE_AKTIVITETER_SETTING, default: true },
  datumFr: { key: BO_DATUM_FRAN_SETTING, default: '' },
  datumTill: { key: BO_DATUM_TILL_SETTING, default: '' },
  isValidDateFr: { key: BO_IS_VALID_DATE_FRAN_SETTING, default: false },
  isValidDateTi: { key: BO_IS_VALID_DATE_TILL_SETTING, default: false },
  typeCondition: { key: BO_TYPE_CONDITION_SETTING, default: null },
  bokningsrubriker: {
    key: BO_BOKNINGSRUBRIKER_SETTING,
    default: [] as IBokningsrubrik[],
  },
} as const;

export const usePlaneringSettings = () => {
  const [
    storedPlaneringSetting,
    setStoredPlaneringSetting,
    ,
    loadingPlanering,
  ] = useLocalStorage<boolean>(
    PLANERING_SETTINGS.planeradeAktiviteter.key,
    PLANERING_SETTINGS.planeradeAktiviteter.default
  );
  const [
    bokadeAktiviteterSetting,
    setStoredBokadeAktiviteterSetting,
    ,
    loadingBokade,
  ] = useLocalStorage<boolean>(
    PLANERING_SETTINGS.bokadeAktiviteter.key,
    PLANERING_SETTINGS.bokadeAktiviteter.default
  );
  const [datumFrSetting, setStoredDatumFrSetting, , loadingDatumFr] =
    useLocalStorage<string>(
      PLANERING_SETTINGS.datumFr.key,
      PLANERING_SETTINGS.datumFr.default
    );
  const [datumTillSetting, setStoredDatumTillSetting, , loadingDatumTill] =
    useLocalStorage<string>(
      PLANERING_SETTINGS.datumTill.key,
      PLANERING_SETTINGS.datumTill.default
    );
  const [
    isValidDateFrSetting,
    setStoredIsValidDateFrSetting,
    ,
    loadingIsValidDateFr,
  ] = useLocalStorage<boolean>(
    PLANERING_SETTINGS.isValidDateFr.key,
    PLANERING_SETTINGS.isValidDateFr.default
  );
  const [
    isValidDateTiSetting,
    setStoredIsValidDateTiSetting,
    ,
    loadingIsValidDateTi,
  ] = useLocalStorage<boolean>(
    PLANERING_SETTINGS.isValidDateTi.key,
    PLANERING_SETTINGS.isValidDateTi.default
  );

  const [typeConditionSetting, setTypeConditionSetting] =
    useLocalStorage<ITypeTreeConditionObject | null>(
      PLANERING_SETTINGS.typeCondition.key,
      PLANERING_SETTINGS.typeCondition.default
    );
  const [bokningsrubriker, setBokningsrubriker, , loadingBokningsrubriker] =
    useLocalStorage<IBokningsrubrik[]>(
      PLANERING_SETTINGS.bokningsrubriker.key,
      PLANERING_SETTINGS.bokningsrubriker.default
    );

  return {
    storedPlaneringSetting,
    setStoredPlaneringSetting,
    bokadeAktiviteterSetting,
    setStoredBokadeAktiviteterSetting,
    datumFrSetting,
    setStoredDatumFrSetting,
    datumTillSetting,
    setStoredDatumTillSetting,
    isValidDateFrSetting,
    setStoredIsValidDateFrSetting,
    isValidDateTiSetting,
    setStoredIsValidDateTiSetting,
    typeConditionSetting,
    setTypeConditionSetting,
    bokningsrubriker,
    setBokningsrubriker,
    loading:
      loadingPlanering ||
      loadingBokade ||
      loadingDatumFr ||
      loadingDatumTill ||
      loadingIsValidDateFr ||
      loadingIsValidDateTi ||
      loadingBokningsrubriker,
  };
};
